import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Row, Tabs, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BankOnStatus from "./BankOnStatus";
import { useAppDispatch, useAppSelector } from "store";
import { useLoadBankList } from "hooks/useFactory";
import dayjs from "dayjs";
import { setBankEndDate, setBankStartDate } from "store/slices/bankSlice";


const ManageBank = () => {
    const navigate = useNavigate();

    const { contact } = useAppSelector((state) => state.auth);

    const [currentActivePage, setCurrentActivePage] = useState(1);
    const itemsActivePerPage = 9;
    const startActiveIndex = (currentActivePage - 1) * itemsActivePerPage;
    const endActiveIndex = currentActivePage * itemsActivePerPage;

    const [currentInactivePage, setCurrentInactivePage] = useState(1);
    const itemsInactivePerPage = 9; 
    const startInactiveIndex = (currentInactivePage - 1) * itemsInactivePerPage;
    const endInactiveIndex = currentInactivePage * itemsInactivePerPage;

    const bankData =  useAppSelector((state) => state.bank);

    const dispatch = useAppDispatch();
    const currentYear = dayjs().year();
    const firstDayOfYear = dayjs(`${currentYear}-01-01`);
    const lastDayOfYear = dayjs(`${currentYear}-12-31`);
  
    const [startDate, setStartDate] = useState<any>(bankData.start_date || firstDayOfYear);
    const [endDate, setEndDate] = useState<any>(bankData.end_date || lastDayOfYear);

    const handleDateChange = (dates: any, dateStrings: [string, string]) => {
      if (dates) {
        setStartDate(dates[0] ? dates[0] : undefined);
        setEndDate(dates[1] ? dates[1] : undefined);
      } else {
        setStartDate('');
        setEndDate('');
        dispatch(setBankStartDate(null));
        dispatch(setBankEndDate(null));
      }
    };
  
    const handleSearch = () => {
      dispatch(setBankStartDate(startDate));
      dispatch(setBankEndDate(endDate));
    };
    
    const { data: dataBank, refetch:refetchBank } = useLoadBankList({
      start_date: bankData.start_date ? dayjs(bankData.start_date).locale('th').format('YYYY-MM-DD') : '',
      end_date: bankData.end_date ? dayjs(bankData.end_date).locale('th').format('YYYY-MM-DD')  : '',
      status: "active",
      offset: startActiveIndex,
      limit: endActiveIndex
    });

    const { data: dataInactive, refetch:refetchInactive } = useLoadBankList({
      start_date: bankData.start_date ? dayjs(bankData.start_date).locale('th').format('YYYY-MM-DD') : '',
      end_date: bankData.end_date ? dayjs(bankData.end_date).locale('th').format('YYYY-MM-DD')  : '',
      status: "inactive",
      offset: startInactiveIndex,
      limit: endInactiveIndex
    });

    const activeBankCount = Number(dataBank?.data?.total_record ?? 0);
    const isLunganekContact = contact?.code === "lunganek";

    const items = [
        {
          label: `เปิดใช้งาน (${dataBank?.data?.total_record ?? 0})`,
          key: "1",
          children: (
          <BankOnStatus
            data={dataBank?.data}
            refetch={refetchBank}
            refetchTo={refetchInactive}
            currentPage={currentActivePage} 
            setCurrentPage={setCurrentActivePage} 
            itemsPerPage={itemsActivePerPage}
            handleDateChange={handleDateChange}
            handleSearch={handleSearch}
            startDate={startDate}
            endDate={endDate}
            activeBankCount={activeBankCount}
            isLunganek={isLunganekContact}
          />
          ),
        },
        {
          label: `ปิดใช้งาน (${dataInactive?.data?.total_record ?? 0})`,
          key: "2",
          children:
          <BankOnStatus
            data={dataInactive?.data}
            refetch={refetchInactive}
            refetchTo={refetchBank}
            currentPage={currentInactivePage} 
            setCurrentPage={setCurrentInactivePage} 
            itemsPerPage={itemsInactivePerPage}      
            handleDateChange={handleDateChange}  
            handleSearch={handleSearch}
            startDate={startDate}
            endDate={endDate}
            activeBankCount={activeBankCount}
            isLunganek={isLunganekContact}
          />
          ,
        },
    ];
 
    return (
        <>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper onClick={() => {
                navigate("/setting");
              }}>
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <>
                <Typography.Title level={5}>บัญชีธนาคาร</Typography.Title>
              </>
              <RightIconWrapper>
              </RightIconWrapper>
            </HeaderTabs>
            <Row className="rowgap-vbox" gutter={[24, 0]}>
              <Col sm={24} md={24}>
              <Tabs
                defaultActiveKey="1"
                style={{ height: "100%" }}
                items={items}
              />
              </Col>

            </Row>
 
          </Card>
       </>
    )
};

export default ManageBank;


const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

 